module.exports={render:function (){with(this) {
  return _h('div', [_h('section', {
    staticClass: "main"
  }, [_m(0), " ", _h('div', {
    staticClass: "board"
  }, [_h('nav', [_h('router-link', {
    staticClass: "tile",
    attrs: {
      "to": "startup-innovation"
    }
  }, [_h('svg', [_h('use', {
    attrs: {
      "xlink:href": "#rocket"
    }
  })]), " ", _m(1)]), " ", _h('router-link', {
    staticClass: "tile",
    attrs: {
      "to": "corporate-innovation"
    }
  }, [_h('svg', [_h('use', {
    attrs: {
      "xlink:href": "#train"
    }
  })]), " ", _m(2)]), " ", _h('router-link', {
    staticClass: "tile",
    attrs: {
      "to": "smart-energy-systems"
    }
  }, [_h('svg', [_h('use', {
    attrs: {
      "xlink:href": "#grid"
    }
  })]), " ", _m(3)]), " ", _h('router-link', {
    staticClass: "tile",
    attrs: {
      "to": "future-energy-system"
    }
  }, [_h('svg', [_h('use', {
    attrs: {
      "xlink:href": "#circle"
    }
  })]), " ", _m(4)]), " ", _h('router-link', {
    staticClass: "tile",
    attrs: {
      "to": "cleantech-startup-map"
    }
  }, [_h('svg', [_h('use', {
    attrs: {
      "xlink:href": "#map"
    }
  })]), " ", _m(5)]), " ", _h('router-link', {
    staticClass: "tile",
    attrs: {
      "to": "contact-about"
    }
  }, [_h('svg', [_h('use', {
    attrs: {
      "xlink:href": "#bubble"
    }
  })]), " ", _m(6)])]), " ", _h('router-view')])]), " ", _m(7), " ", _m(8)])
}},staticRenderFns: [function (){with(this) {
  return _h('header', [_h('h1', ["Innovation with Energy."])])
}},function (){with(this) {
  return _h('div', [_h('h2', ["Start-up Innovation"])])
}},function (){with(this) {
  return _h('div', [_h('h2', ["Corporate Innovation"])])
}},function (){with(this) {
  return _h('div', [_h('h2', ["Smart Energy Systems"])])
}},function (){with(this) {
  return _h('div', [_h('h2', ["Future Energy System"])])
}},function (){with(this) {
  return _h('div', [_h('h2', ["Cleantech Startup Map"])])
}},function (){with(this) {
  return _h('div', [_h('h2', ["Contact | About"])])
}},function (){with(this) {
  return _h('section', {
    attrs: {
      "id": "partners"
    }
  }, [_h('h3', ["Clients and partners"]), " ", _h('div', {
    staticClass: "partners"
  }, [_h('a', {
    attrs: {
      "href": "//www.rwe.de",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "rwe-innovation",
    attrs: {
      "alt": "RWE Innovation Hub",
      "title": "RWE Innovationhub",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.enel.it",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "enel",
    attrs: {
      "alt": "Enel",
      "title": "Enel",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.laboratories.telekom.com",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "telekominnovation",
    attrs: {
      "alt": "Telekom Innovation Labs",
      "title": "Telekom Innovation Labs",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.dena.de",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "dena",
    attrs: {
      "alt": "Dena",
      "title": "Dena",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.startupnight.de",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "langenacht",
    attrs: {
      "alt": "Lange Nacht der Startups",
      "title": "Lange Nacht der Startups",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.climate-kic.org",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "eitclimate",
    attrs: {
      "alt": "EIT Climate kic",
      "title": "EIT Climate kic",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.hubraum.com",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "hubraum",
    attrs: {
      "alt": "hubraum",
      "title": "hubraum",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.entrepreneurship.tu-berlin.de",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "cfe",
    attrs: {
      "alt": "CfE Logo",
      "title": "Centre for Entrepreneurship",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.incense-accelerator.com",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "incense",
    attrs: {
      "alt": "Incense Energy Accelerator",
      "title": "Incense Energy Accelerator",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//cleantechpark.de",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "cleantech",
    attrs: {
      "alt": "Cleantech Businesspark Berlin-Marzahn",
      "title": "Cleantech Businesspark Berlin-Marzahn",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.eitdigital.eu/idea-challenge/about/",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "ideachallenge",
    attrs: {
      "alt": "EIT Idea Challenge",
      "title": "EIT Idea Challenge",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.rohrbeckheger.com",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "rohrbeckheger",
    attrs: {
      "alt": "Rohrbeck Heger GmbH",
      "title": "Rohrbeck Heger GmbH",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.eitdigital.eu",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "eitdigital",
    attrs: {
      "alt": "EIT Digital Logo",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "//www.vattenfall.de",
      "target": "_blank"
    }
  }, [_h('img', {
    staticClass: "vattenfall",
    attrs: {
      "alt": "vattenfall",
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="
    }
  })])])])
}},function (){with(this) {
  return _h('footer', [_h('ul', [_h('li', [_h('a', {
    attrs: {
      "href": "impressum"
    }
  }, ["Impressum"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "privacy"
    }
  }, ["Datenschutz"])])])])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb6ed712!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 39
// module chunks = 1